var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedLastRun({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4062 16 16 12.4375 16 8C16 3.59375 12.4062 0 8 0C3.5625 0 0 3.59375 0 8C0 12.4375 3.5625 16 8 16ZM5.46875 5.46875C5.75 5.1875 6.21875 5.1875 6.5 5.46875L7.96875 6.9375L9.4375 5.46875C9.75 5.1875 10.2188 5.1875 10.5 5.46875C10.8125 5.78125 10.8125 6.25 10.5 6.53125L9.03125 8L10.5 9.46875C10.8125 9.78125 10.8125 10.25 10.5 10.5312C10.2188 10.8438 9.75 10.8438 9.4375 10.5312L7.96875 9.0625L6.5 10.5312C6.21875 10.8438 5.75 10.8438 5.46875 10.5312C5.15625 10.25 5.15625 9.78125 5.46875 9.46875L6.9375 8L5.46875 6.53125C5.15625 6.25 5.15625 5.78125 5.46875 5.46875Z",
    fill: "#D7352B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedLastRun);
export default __webpack_public_path__ + "static/media/failed-last-run.97778184dbd9b7c4541deecfaf87dd89.svg";
export { ForwardRef as ReactComponent };